import {GpHoldingListItemReqRes} from 'src/app/dashboard/shared/holding/GpHoldingListItem.model';
import { BaseResponseDto } from 'src/app/shared/models/BaseResponseDto.model';
import ContactsVisibilityPermission from '../enums/contactsVisibilityPermission.enum';
import {FinancialPermissionLevel} from '../enums/financialPermissionLevel.enum';
import PermissionLevel from '../enums/permissionLevel.enum';
import SectionsAccess from '../enums/sectionsAccess.enum';
import ViewAsInvestorPermission from '../enums/view-as-investor-permission';

export class UserPermissionDto extends BaseResponseDto {
  constructor(id: number) {
    super();
    this.id = id;
  }

  id: number;
  clientId: number;
  name: string;
  email: string;
  permissionLevel: PermissionLevel;
  allowedSections: SectionsAccess;
  financialPermission: FinancialPermissionLevel;
  holdings: GpHoldingListItemReqRes[];
  comment: string;
  contactsVisibility: ContactsVisibilityPermission;
  viewAsInvestor: ViewAsInvestorPermission;
}
